import styled from "styled-components";
import {GameNumberBadgeDefaultBox} from "./game-number-badge.default.box";

export const GameNumberBadgeWsopBox = styled(GameNumberBadgeDefaultBox)`
    position: relative;
    left: 6px;
    font-family: ${({theme}) => theme.font.family.black};
    font-size: 6.5em;
    letter-spacing: -0.05em;
    line-height: 0.9;
    -webkit-text-stroke: 1px ${({theme}) => theme.colors.brandPrimary};

    text-shadow: #00000080 0 4px 3px;

    @media ${({theme}) => theme.mediaQuery.lAndAbove} {
        left: 0;
        -webkit-text-stroke-width: 2px;
    }
`;